<div class="relative">
    <companyid-feature-slider
        class="flex sticky top-0 py-40px bg-white/100"
        (chooseFeatureTitle)="anchorScroll($event, featureItems())"
        [currentIndex]="activeId()" />

    <companyid-content-wrapper classNames="flex-col w-full pt-40px tab:px-5 mob:px-5">
        <companyid-title-and-subtitle
            i18n-title="@@title-our-features"
            i18n-subtitle="@@subtitle-discover-companyid"
            title="Our Features"
            subtitle="Discover CompanyID"
            class="pb-80px mob:text-center tab:text-center" />
        <div class="flex flex-col desk:gap-y-120px tab:gap-80px mob:gap-y-80px relative">
            @for (feature of featuresContent; let i = $index; track feature.title) {
                <div class="flex w-full mob:flex-col mob:scroll-mt-[180px]" #featureItems [id]="i">
                    <companyid-feature-item
                        [feature]="feature"
                        class="flex w-full mob:justify-center tab:justify-center" />
                </div>
            }
            <div>
                @for (avatar of avatarContent; track avatar.title) {
                    <companyid-avatar-with-message
                        [classNames]="avatar.classNames"
                        [title]="avatar.title"
                        [subtitle]="avatar.subtitle"
                        [position]="avatar.position"
                        [avatarImg]="avatar.avatarImg" />
                }
            </div>
        </div>
    </companyid-content-wrapper>
</div>
